<template>
    <div class="genomics-bb-tools clearfix">
        <div class="genomice-search-left" v-if="isSToolsVisible">
            <span class="genomic-search-label">筛选对比：</span>
            <a-dropdown :disabled="disabledH" overlayClassName="hospital-dropdown-overlay"
                class="hospital-dropdown-link">
                <a class="ant-dropdown-link">
                    {{ searchLableH }}
                    <a-icon type="down" />
                </a>
                <a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
                    @click="onClickSearchH">
                    <a-menu-item key="-1">
                        <a href="javascript:;" class="genomice-search-item-fontsize">全部</a>
                    </a-menu-item>
                    <a-menu-item v-for="item in searchQueryData.dataH" :key="item.id">
                        <a href="javascript:;" class="genomice-search-item-fontsize">
                            <span>{{ item.name }}</span>
                            <template v-for="classes in item.classes">
                                <span class="genomice-search-classes-style"
                                    :style="{ 'backgroundColor': getDiscColor(classes.name) }">
                                    {{ classes.number }}
                                </span>
                            </template>
                        </a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
            <a-dropdown :disabled="disabledC" overlayClassName="hospital-dropdown-overlay"
                class="hospital-dropdown-link">
                <a class="ant-dropdown-link">
                    {{ searchLableC }}
                    <a-icon type="down" />
                </a>
                <a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
                    @click="onClickSearchC">
                    <a-menu-item key="-1">
                        <a href="javascript:;">全部</a>
                    </a-menu-item>
                    <a-menu-item v-for="item in searchQueryData.dataC" :key="item.name">
                        <a href="javascript:;" class="genomice-search-item-fontsize">
                            <span>{{ item.name }}</span>
                            <template v-for="classes in item.classes">
                                <span class="genomice-search-classes-style"
                                    :style="{ 'backgroundColor': getDiscColor(classes.name) }">
                                    {{ classes.number }}
                                </span>
                            </template>
                        </a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
            <a-cascader class="m-input-s" :value="molecular" :disabled="disabledM" :options="searchQueryData.dataM"
                placeholder="分子分型" expand-trigger="hover" changeOnSelect @change="onChangeSearchM" />
            <a-dropdown :disabled="disabledB" overlayClassName="hospital-dropdown-overlay"
                class="hospital-dropdown-link">
                <a class="ant-dropdown-link">
                    {{ searchLableB }}
                    <a-icon type="down" />
                </a>
                <a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
                    @click="onClickSearchB">
                    <a-menu-item key="-1">
                        <a href="javascript:;">全部</a>
                    </a-menu-item>
                    <a-menu-item v-for="item in searchQueryData.dataB" :key="item.name">
                        <a href="javascript:;" class="genomice-search-item-fontsize">
                            <span>{{ item.name }}</span>
                            <template v-for="classes in item.classes">
                                <span class="genomice-search-classes-style"
                                    :style="{ 'backgroundColor': getDiscColor(classes.name) }">
                                    {{ classes.number }}
                                </span>
                            </template>
                        </a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
        </div>
        <div class="genomice-search-right">
            <!-- <a-input :size="size" placeholder="chr1:47194417-47322785" /> -->
            <!-- <span class="g-s-close" v-if="initType != 'default'" @click="del(keyVal)">×</span> -->
            <span class="f-export" @click="exportExcelAll()">下载excel</span>
            <span class="f-export" v-if="initType == 'default'" @click="exportImgAll()">下载图片</span>
            <span class="f-icon-span">
                <a-icon type="table" class="f-icon-ck" @click="discClickFun()" />
            </span>
        </div>
        <drag-modal :visible="isVisible" :width="'75%'" :footer="false" :mask="false">
            <genomics-pos-info v-if="isVisible" :queryData="posDiscData" :geneName="apiOption.geneName"
                :partName="apiOption.transcriptId" @cancel="() => isVisible = false"></genomics-pos-info>
        </drag-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import NProgress from 'nprogress';
import html2canvas from 'html2canvas';
import genomicsACCUtils from "../../common/genomics-AACUtils";
import GenomicsPosInfo from '../../views/molecularData/genomics-pos-info.vue';

export default {
    components: { GenomicsPosInfo, },
    computed: {
        ...mapState({
            user: (state) => state.account.user,
        }),
    },
    props: {
        apiOption: {
            type: Object,
            default: () => { },
        },
        checkeds: {
            type: Object,
            default: () => { },
        },
        searchQueryData: {
            type: Object,
            default: () => { },
        },
        initType: {
            type: String,
            default: () => { },
        },
        keyVal: {
            type: String,
            default: () => { },
        }
    },
    data() {
        return {
            isSToolsVisible: true,
            isVisible: false,
            posDiscData: {},
            size: 'small',
            hospitalId: '',
            clinical: '',
            molecular: null,
            hosBarCode: '',
            /*type=H：医院名称,医院ID（其中医院ID需要隐藏，查询时使用），
      type=C:  P\LP\UVS。
      type=M: 分子分型ID用逗号分隔，如（13,14）。
      type=B: 样本值，如CCCG123。*/
            searchLableH: '合作医院',
            searchLableC: '临床意义',
            searchLableM: '分子分型',
            searchLableB: '样本ID',
            disabledH: false,
            disabledC: false,
            disabledM: false,
            disabledB: false,
            tags: {},
            sResData: {},
        };
    },
    mounted() {
        if (this.initType == 'default') {
            // if (this.user.deptId) {
            //     this.checkeds.hospitalId = this.user.deptId;
            //     this.hospitalId = this.checkeds.hospitalId;
            //     this.disabledH = this.checkeds.hospitalId ? true : false;
            //     this.searchLableH = this.user.deptName;
            // }
            this.getInitData();
        } else {
            this.hospitalId = this.checkeds.hospitalId;
            this.clinical = this.checkeds.clinical;
            this.molecular = this.checkeds.molecular;
            this.hosBarCode = this.checkeds.hosBarCode;
            this.disabledH = this.checkeds.hospitalId ? true : false;
            this.disabledC = this.checkeds.clinical ? true : false;
            this.disabledM = this.checkeds.molecular ? true : false;
            this.disabledB = this.checkeds.hosBarCode ? true : false;
            this.setSearchLable('dataH', this.hospitalId);
            this.setSearchLable('dataC', this.clinical);
            this.setSearchLable('dataB', this.hosBarCode);
        }
        // if(this.initType == 'not'){
        //     this.refreshQueryData();
        // }
    },
    methods: {
        discClickFun(data) {
            this.posDiscData = { tabIndex: 3, tabType: 'all' };
            this.posDiscData.checkeds = this.checkeds;
            this.isVisible = true;
        },
        setSearchLable(key, value) {
            let tmp = '';
            if (value) {
                this.searchQueryData[key].forEach(res => {
                    if (res.id == value) {
                        tmp = res.name;
                        return;
                    }
                });
                switch (key) {
                    case 'dataH':
                        this.searchLableH = tmp;
                        break;
                    case 'dataC':
                        this.searchLableC = tmp;
                        break;
                    case 'dataB':
                        this.searchLableB = tmp;
                        break;
                }
            }
        },
        getTagsStr() {
            let res = 'H' + this.getTagsVal('H') + '-C' + this.getTagsVal('C') + '-M' + this.getTagsVal('M') + '-B' + this.getTagsVal('B');
            return res;
        },
        getTagsVal(key) {
            return this.tags[key] ? this.tags[key] : 0;
        },
        getInitData() {
            this.searchQueryData = Object.assign(this.searchQueryData, {
                dataH: [],
                dataC: [],
                dataM: [],
                dataB: []
            });
            Promise.all([
                this.getSearchBBDataH(),
                this.getSearchBBDataC(),
                this.getSearchBBDataM(),
                this.getSearchBBDataB()
            ]).then(res => {
                this.searchQueryData.dataH = res[0];
                this.searchQueryData.dataC = res[1];
                this.searchQueryData.dataM = res[2];
                this.searchQueryData.dataB = res[3];
            })
        },
        getDiscColor(name) {
            return genomicsACCUtils.discColorMap[name];
        },
        refreshQueryData(type) {
            NProgress.start();
            let emitData = {};
            let tagsVal = this.getTagsStr();
            Promise.all([this.getSearchBBDataH(), this.getSearchBBDataC(), this.getSearchBBDataM(), this.getSearchBBDataB(), this.getSearchBBData()]).then(res => {
                emitData[tagsVal] = {
                    id: 'g-m-' + tagsVal,
                    keys: tagsVal,
                    times: new Date().getTime(),
                    apiOption: this.apiOption,
                    checkeds: {
                        hospitalId: this.hospitalId,
                        clinical: this.clinical,
                        molecular: this.molecular,
                        hosBarCode: this.hosBarCode
                    },
                    searchQueryData: {
                        dataH: res[0], // 合作医院
                        dataC: res[1], // 临床意义
                        dataM: res[2], // 分析分型
                        dataB: res[3], // 样本
                    },
                    bbData: res[4] //bbdata list
                };
                this.$emit('updateSearchQueryData', 2, emitData);
                this.clearQueryData();
            }).finally(() => {
                NProgress.done();
            });
        },
        clearQueryData() {
            this.hospitalId = '';
            this.clinical = '';
            this.molecular = null;
            this.hosBarCode = '';
        },
        onClickSearchH({ key }) {
            this.tags['H'] = key;
            if (key == '-1') {
                this.searchLableH = '合作医院';
                this.hospitalId = '';
            } else {
                this.hospitalId = key;
            }
            this.refreshQueryData()
        },
        onClickSearchC({ key }) {
            this.tags['C'] = key;
            if (key == '-1') {
                this.searchLableC = '临床意义';
                this.clinical = '';
            } else {
                this.clinical = key;
            }
            this.refreshQueryData();
        },
        onChangeSearchM(value) {
            this.tags['M'] = value.join('x');
            this.molecular = value;
            this.refreshQueryData();
        },
        onClickSearchB({ key }) {
            this.tags['B'] = key;
            if (key == '-1') {
                this.searchLableB = '样本ID';
                this.hosBarCode = '';
            } else {
                this.hosBarCode = key;
            }
            this.refreshQueryData();
        },
        /**
         * get bbdata 集合
         */
        getSearchBBData() {
            return new Promise((resolve, reject) => {
                let opt = Object.assign({
                    hospitalId: this.hospitalId,
                    clinical: this.clinical,
                    molecular: this.molecular,
                    hosBarCode: this.hosBarCode,
                }, this.apiOption);
                this.$get("/gene/search_bbdata_list", opt).then(
                    res => {
                        resolve(res.data.data);
                    }, err => {
                        reject(err);
                    })
            })
        },
        /**
         * H:医院名称
         */
        getSearchBBDataH() {
            return new Promise((resolve, reject) => {
                let opt = Object.assign({
                    type: 'H',
                    hospitalId: this.hospitalId,
                    clinical: this.clinical,
                    molecular: this.molecular,
                    hosBarCode: this.hosBarCode,
                }, this.apiOption);
                this.$get("/gene/search_bbdata", opt).then(
                    res => {
                        resolve(res.data.data);
                    }, err => {
                        reject(err);
                    })
            })
        },
        /**
         * C:临床意义
         */
        getSearchBBDataC() {
            return new Promise((resolve, reject) => {
                let opt = Object.assign({
                    type: 'C',
                    hospitalId: this.hospitalId,
                    clinical: this.clinical,
                    molecular: this.molecular,
                    hosBarCode: this.hosBarCode
                }, this.apiOption);
                this.$get("/gene/search_bbdata", opt).then(
                    res => {
                        resolve(res.data.data);
                    }, err => {
                        reject(err);
                    })
            });
        },
        /**
         * M:分子分型
         */
        getSearchBBDataM() {
            return new Promise((resolve, reject) => {
                let opt = Object.assign({
                    type: 'M',
                    hospitalId: this.hospitalId,
                    clinical: this.clinical,
                    molecular: this.molecular,
                    hosBarCode: this.hosBarCode,
                }, this.apiOption);
                this.$get("/gene/search_bbdata", opt).then(
                    res => {
                        resolve(genomicsACCUtils.assJsonData(res.data.data));
                    }, err => {
                        reject(err);
                    })
            });
        },
        /**
         * B:样本信息
         */
        getSearchBBDataB() {
            return new Promise((resolve, reject) => {
                let opt = Object.assign({
                    type: 'B',
                    hospitalId: this.hospitalId,
                    clinical: this.clinical,
                    molecular: this.molecular,
                    hosBarCode: this.hosBarCode,
                }, this.apiOption);
                this.$get("/gene/search_bbdata", opt).then(
                    res => {
                        resolve(res.data.data);
                    }, err => {
                        reject(err);
                    })
            });
        },
        exportImgAll() {
            let element = document.querySelector('.amino-box'), filename = '导出图片', ext = 'png';
            let $this = this;
            $this.isSToolsVisible = false;
            $this.switchDisplay('none');
            setTimeout(function () {
                html2canvas(element, { useCORS: true }).then((canvas) => {
                    if (navigator.msSaveBlob) {
                        const blob = canvas.msToBlob();
                        return navigator.msSaveBlob(blob, name);
                    } else {
                        const imageurl = canvas.toDataURL('image/png');
                        const aLink = document.createElement('a');
                        aLink.style.display = 'none';
                        aLink.href = imageurl;
                        aLink.download = `${filename}.${ext}`;
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink);
                    }
                    $this.isSToolsVisible = true;
                    $this.switchDisplay('block');
                })
            }, 200)


        },
        switchDisplay(val) {
            let switchBtn = document.querySelectorAll('.amino-clb .ant-switch');
            for (let i = 0; i < switchBtn.length; i++) {
                switchBtn[i].style.display = val;
            }
        },
        exportExcelAll() {
            this.exportExcel('snp');
            this.exportExcel('fusion');

        },
        exportExcel(type) {
            let url = "";
            let opt = {};
            let dFilename = "";
            switch (type) {
                case "snp":
                    url = "gene/export_bbdata_snp_list";
                    opt = Object.assign({}, { name: this.apiOption.geneName, partName: this.apiOption.transcriptId }, this.checkeds);
                    dFilename = "突变_位点";
                    break;
                case "fusion":
                    url = "gene/export_bbdata_fusion_list";
                    opt = Object.assign({}, { name: this.apiOption.geneName, partName: this.apiOption.transcriptId }, this.checkeds);
                    dFilename = "融合_位点";
                    break;
            }
            this.$export(url, opt, dFilename);
        },
    }
}
</script>

<style lang="scss" scoped>
.genomice-search-classes-style {
    float: right;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-left: 5px;
    border-radius: 100%;
    background-color: #979797;
}

// .genomice-search-item-fontsize {
//   // font-size: 12px;
// }
.genomics-bb-tools {
    margin: 10px 0 5px 0;

    .hospital-dropdown-link {
        margin-left: 5px;
        margin-right: 10px;
    }

    .hospital-dropdown-link {
        display: inline-block;
        color: #9B9B9B;
        font-size: 12px;
        height: 22px;
        line-height: 22px;
        background: #F7F7F7;
        border: 1px solid #F0F2F5;
        padding: 0 7px;
    }

    .ant-dropdown-open {
        color: #162232;
    }

    /deep/.ant-input {
        font-size: 12px;
        height: 22px;
        line-height: 22px;
        background-color: #F7F7F7;
        border: 1px solid #F0F2F5;
        border-radius: 0;
    }

    /deep/input::-webkit-input-placeholder {
        color: #9B9B9B;
    }

    /deep/.m-input-s:hover input::-webkit-input-placeholder {
        color: #162232;
    }

    /deep/.ant-cascader-input.ant-input {
        background-color: #F7F7F7 !important;
    }

    /deep/ .ant-cascader-picker-label {
        font-size: 12px;

    }


    /deep/.ant-cascader-picker-arrow {
        color: #9B9B9B;
        font-size: 11px;
    }

    .m-input-s {
        min-width: 100px;
    }

    .genomice-search-left {
        float: left;
        font-size: 12px;
        color: #9B9B9B;

    }

    .genomice-search-right {
        float: right;
        font-size: 12px;
        text-align: right;
        padding-right: 28px;

        .f-export {
            display: inline-block;
            background: #4C83FF;
            color: #FFFFFF;
            font-size: 12px;
            line-height: 22px;
            padding: 2px 10px;
            cursor: pointer;
            margin-right: 20px;
        }

        .f-icon-span {
            display: inline-block;
            background-color: #dde8fc;
            padding: 0px 6px;
            height: 26px;
            line-height: 24px;
        }

        .f-icon-ck {
            font-size: 16px;
            vertical-align: middle;
        }

        /deep/ .ant-input {
            font-size: 12px;
        }

        .g-s-close {
            line-height: 46px;
            font-size: 26px;
            vertical-align: middle;
            cursor: pointer;
        }
    }
}
</style>